import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import Book from '@material-ui/icons/Book';
import Link from '@material-ui/icons/Link';

import { CLEAR_SEARCH_DATA } from '../actions/actionTypes'
import { addSearchHistory, getSearchHistory } from '../services/storageService'

const searchCategories = [
    {
        category: 'sigaa',
        avatar: <Book />,
        description: 'Busca no SIGAA',
    },    
    {
        category: 'repository',
        avatar: <Link />,
        description: 'Busca em base digital',
    },
]

export default function RecentSearches(props) {
    const dispatch = useDispatch()
    const [searchList, setSearchList] = useState([])

    useEffect(() => {
        setSearchList(getSearchHistory())
    }, [])

    const searchInfo = item => {
        let category = searchCategories.find(element => element.category === item.category)
        return category || searchCategories[0]
    }

    const getDescription = item => item.title || item.author || item.subject

    const search = item => {
        addSearchHistory(item.category, item.title, item.author, item.subject)
        dispatch({ type: CLEAR_SEARCH_DATA })
        
        const params = {
            title: item.title,
            author: item.author,
            subject: item.subject,
            category: item.category,
        }

        if(item.category === 'repository'){
            params.repository = true
            params.material = 'all'
        }

        props.history.push({
            pathname: '/search-result',
            search: new URLSearchParams(params).toString()
        })
    }

    return (
        <Box flexGrow={1}>
            {!searchList.length &&
                <Box mt={2}>
                    <Typography align="center" variant="subtitle1" color="primary">
                        Você ainda não realizou nenhuma busca
                    </Typography>
                </Box>
            }

            <List>
                {searchList.map((item, index) =>
                    (getDescription(item) && 
                        <ListItem button divider={true} key={index} onClick={() => search(item)} >
                            <ListItemIcon>
                                {searchInfo(item).avatar}
                            </ListItemIcon>
                            <ListItemText primary={getDescription(item)} secondary={searchInfo(item).description} />
                        </ListItem>
                    )
                )}
                
            </List>
            <Box display="flex" flexGrow={1} p={1} justifyContent="center">
                <Button
                    fullWidth={true}
                    color="primary"
                    onClick={() => props.history.goBack()}
                >
                Voltar
                </Button>
            </Box>
        </Box>
    );
}